import Recaptcha from 'react-google-recaptcha'
import React, { PureComponent } from 'react'
import styles from './recaptcha_form.scss'
import config from 'config'

class RecaptchaForm extends PureComponent {

	constructor(props) {
		super(props)
		this.captcha = null
	}

	getValue() {
		return this.captcha ? this.captcha.getValue() : ''
	}

	reset() {
		if (this.captcha) {
			this.captcha.reset()
		}
	}

	render() {
		/*if(this.props.meta.error || this.props.error || this.props.input.error) {
			console.log('I HAVE RROR:', this.props)
		}*/
		const value = this.props.meta.dirty ? this.props.input.value : this.props.meta.initial || ''
		return (
			<div>
				<div className={styles.captcha}>
					<Recaptcha
						size="normal"
						onChange={this.props.input.onChange}
						sitekey={config.recaptcha.site_key}
						ref={el => {
							this.captcha = el
						}}
					/>
				</div>
				<div className={styles['captcha-error']}>{this.props.getMessage(this.props.meta, this.props.input.name, value)}</div>
			</div>
		)
	}
}

RecaptchaForm.defaultProps = {
}

export default RecaptchaForm
